/*
 * Figma „Mobile-navbar“ (290:37740): the tab row is 57 px (8 px top padding + 49 px tabs) above the
 * home indicator, which on the web is the safe area. Everything the bar covers is kept clear with
 * these – literal class strings so Tailwind sees them.
 */

/** Height of the fixed bar: page spacer under the footer. */
export const BAR_HEIGHT = 'h-[calc(57px+env(safe-area-inset-bottom))]';

/** Bottom padding of the categories view: the bar plus the Figma 24 px under the content. */
export const BAR_CLEARANCE = 'pb-[calc(81px+env(safe-area-inset-bottom))]';
